module.exports = __webpack_public_path__ + "img/bottom.98d521c.png";